import * as React from 'react';

import { IOfferTypeSelectProps, OfferTypeSelect } from './OfferTypeSelect';
import { ETestId } from '../../../common/constants';

export const OfferTypeSelectModal: React.FC<IOfferTypeSelectProps> = sharedProps => {
  return (
    <div data-testid={ETestId.RedesignedFiltersOfferTypeModal}>
      <OfferTypeSelect {...sharedProps} />
    </div>
  );
};
